import React from 'react';
import s from './s.module.less';
import ProgressIndicator from '../ProgressIndicator';

interface OnboardingStepContainerProps {
    currentStep: number;
    totalSteps: number;
    title: string;
    subtitle?: string | React.ReactNode;
    showBackButton?: boolean;
    onBack?: () => void;
    children: React.ReactNode;
}

export default function OnboardingStepContainer({
    currentStep,
    totalSteps,
    title,
    subtitle,
    showBackButton = false,
    onBack,
    children,
}: OnboardingStepContainerProps) {
    return (
        <div className={s.container}>
            <ProgressIndicator currentStep={currentStep} totalSteps={totalSteps} />

            <div className={s.contentSection}>
                {/* {showBackButton && (
                    <button type="button" className={s.backButton} onClick={onBack}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                clipRule="evenodd"
                                d="M11.4142 3.58579C11.8047 3.97631 11.8047 4.60948 11.4142 5L7.82843 8.58579C7.04738 9.36683 7.04738 10.6332 7.82843 11.4142L11.4142 15C11.8047 15.3905 11.8047 16.0237 11.4142 16.4142C11.0237 16.8047 10.3905 16.8047 10 16.4142L6.41421 12.8284C4.63317 11.0474 4.63317 8.95262 6.41421 7.17157L10 3.58579C10.3905 3.19526 11.0237 3.19526 11.4142 3.58579Z"
                                fill="#9CA3AF"
                                fillRule="evenodd"
                            />
                        </svg>
                        Back
                    </button>
                )} */}

                <div className={s.textSection}>
                    <h2 className={s.title}>{title}</h2>
                    {subtitle && <p className={s.subtitle}>{subtitle}</p>}
                </div>

                <div className={s.childrenContainer}>
                    {children}
                </div>
            </div>
        </div>
    );
}
